module.exports = __webpack_public_path__ + "img/i.0fbab987.jpg";